import { ClaimService } from 'gw-capability-claim';

export let preLoadInfo = undefined;

let fetchPreload = undefined;
let triedToFetch = false;
const getPreLoadInfo = (authHeader) =>{
    if(!preLoadInfo && authHeader && !triedToFetch){
        triedToFetch = true;
        const claimsPromise = ClaimService.getPreLoadInfo(authHeader);
        fetchPreload = claimsPromise;
        return {'promise':claimsPromise,'fetchStatus':triedToFetch};         
    }
    return {'promise':fetchPreload,'fetchStatus':triedToFetch};
}

export const setPreLoadInfo = (preLoadInfoval) =>{
    preLoadInfo = preLoadInfoval;
}


export default getPreLoadInfo;